import styles from '../../DealerLocator.module.scss';
import cx from 'classnames';
interface DealerLocatorSearchResultBranchNameProps {
  children?: string;
  isStoreLocationListViewUpdateFlag?: boolean;
  isStoreLocationMapViewUpdateFlag?: boolean;
}

export const DealerLocatorSearchResultBranchName = ({
  children,
  isStoreLocationListViewUpdateFlag = false,
  isStoreLocationMapViewUpdateFlag = false
}: DealerLocatorSearchResultBranchNameProps) => (
  <p
    className={cx(
      styles['dealer-locator-text'],
      'cat-u-theme-typography-label-lg u-color--Black mb-0',
      {
        'mt-1': isStoreLocationListViewUpdateFlag,
        'mt-3': !isStoreLocationListViewUpdateFlag,
        'fw-bold': isStoreLocationMapViewUpdateFlag
      }
    )}
  >
    {children}
  </p>
);
